export default "__VITE_ASSET__PzCrrMB2__"